module.exports = __webpack_public_path__ + "static/media/Hero-Inflatables-4.649a1197.jpg";